import { SET_CONFIG,SET_CONTENU } from "./actionTypes";


export const setConfig = config => ({
  type: SET_CONFIG,
  payload: {
    ...config,
  }
});

export const setContenu = contenu => ({
  type: SET_CONTENU,
  payload: {
    ...contenu,
  }
});